/**
 * Bill Credits Selectors
 */
import { createSelector } from 'reselect';

const billCreditsReducer = (state) => state.get('billCreditsReducer');

/**
 * Retrieves loading state from bill credits reducer
 */
export const loadingSelector = createSelector(billCreditsReducer, (state) =>
  state.get('loading'),
);

/**
 * Retrieves error state from bill credits reducer
 */
export const errorSelector = createSelector(billCreditsReducer, (state) =>
  state.get('error'),
);

/**
 * Retrieves a billCredit state from bill credits reducer
 */
export const billCreditSelector = createSelector(billCreditsReducer, (state) =>
  state.get('billCredit').toJS(),
);

/**
 * Retrieves the billCredits state from bill credits reducer
 */
export const billCreditsSelector = createSelector(billCreditsReducer, (state) =>
  state.get('billCredits').toJS(),
);

/**
 * Retrieves count state from bill credits reducer
 */
export const countSelector = createSelector(billCreditsReducer, (state) =>
  state.get('count'),
);
